import { combineReducers } from 'redux'

import user from './user'
import ally from './ally'
import td from './td'
import discord from './discord'
import discordManager from './discordmanager'
import discordUser from './discorduser'

export default combineReducers({user, ally, td, discord, discordManager, discordUser})